import { useLayer } from '@statsig/react-bindings';

import { ExperimentLayers } from '../../statsig/experiments';

export function useEndOfSessionNudgeExperiment() {
  const [layerName, { shouldSeeIntakeNudge }] = ExperimentLayers.FollowUpScheduling;
  return useLayer(layerName).get<boolean>(shouldSeeIntakeNudge, false) ?? false;
}
